/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import jsontocsvConvertion from './jsontocsvConvertion';
import { decrypt_data } from '../../shared/utils';
import { FetchGoogleSpredSheetData } from '../../shared/api/url-helper';
import ProductionSVG from '../ro-input/svg';
import SchematiDiagramSVG from '../edi-input/schematic-view-svg';

let clroImage = [];
let dssroColumnSpace = 3;
let ediColumnSpace = 2;
let imageIndex = [];
let ediImage = [];
function CreateGoogleSheet(props) {
  const { report_invoice, pdfoption, text, flowSheetSolvdData, flowSheetImage, onSheetCreated } = props;
  const {t} = useTranslation();
  const translateObject = t;
  report_invoice.report_dict.pdfoption = pdfoption;
  const checkDisabled = () => {
    const dssroVal = Object.values(flowSheetSolvdData.unitop_output).filter((ele) => {
      return ele.unit_type === 'CLRO';
    });
    if (dssroVal.length > 0) {
      return dssroVal;
    }
    return {};
  };
  /**
   * comment by chandrashekhar because we have written another places
   * After Aunthenticate fetch the google data
   */
  // const GoogleFinalData = jsontocsvConvertion(report_invoice.report_dict, checkDisabled(), flowSheetImage);
  /**
 * comment by chandrashekhar because we have written another places
 * After Aunthenticate fetch the google data
 */
  // TODO(developer): Set to client ID and API key from the Developer Console
  // const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  // const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

  const env_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const CLIENT_ID = decrypt_data(env_CLIENT_ID);
  const env_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
  const API_KEY = decrypt_data(env_API_KEY);

  const [, setSpreadSheetID] = useState('');
  // Discovery doc URL for APIs used by the quickstart
  const DISCOVERY_DOC = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'];
  // 'https://sheets.googleapis.com/$discovery/rest?version=v4';
  // Authorization scopes required by the API; multiple scopes can be
  // included, separated by spaces.
  const SCOPES = ['https://www.googleapis.com/auth/spreadsheets', 'https://www.googleapis.com/auth/drive'];
  let tokenClient;

  async function initializeGapiClient() {
    await window.gapi.client.init({
      apiKey: API_KEY,
      discoveryDocs: DISCOVERY_DOC,
    });
  }
  const gisLoaded = () => {
    tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES.join(' '),
      callback: '', // defined later
    });
  };
  const gapiLoaded = () => {
    window.gapi.load('client', initializeGapiClient);
  };
  /**
  * Callback after api.js is loaded.
  */

  /**
    * Callback after the API client is loaded. Loads the
    * discovery doc to initialize the API.
    */

  /**
    * Enables user interaction after all libraries are loaded.
    */
  async function updateSpreadsheetAndHideSheet(spreadsheetId, callback) {
    // Get the sheet ID for "Sheet1"
    const sheetsResponse = await window.gapi.client.sheets.spreadsheets.get({
      'spreadsheetId': spreadsheetId
    });

    const sheet1 = sheetsResponse.result.sheets.find(sheet => sheet.properties.title === 'Sheet1');

    if (!sheet1) {
      return;
    }

    const sheet1Id = sheet1.properties.sheetId;

    // Prepare the request to hide Sheet1
    const hideSheetRequest = {
      updateSheetProperties: {
        properties: {
          sheetId: sheet1Id,
          hidden: true
        },
        fields: 'hidden'
      }
    };

    // Combine with other updates
    const batchUpdateRequest = {
      requests: [hideSheetRequest]
    };

    // Send the batch update request
    try {
      const response = await window.gapi.client.sheets.spreadsheets.batchUpdate({
        'spreadsheetId': spreadsheetId,
        resource: batchUpdateRequest,
      });

      if (callback) callback(response);
      return response;
    } catch (error) {
      console.error('Error updating spreadsheet:', error);
      throw error;
    }
  };
  const mergeCellGoogleSheet = (sheetId, startRowIndex, endRowIndex, startColumnIndex, endColumnIndex) => {
    return {
      'range': {
        'sheetId': sheetId,
        'startRowIndex': startRowIndex,
        'endRowIndex': endRowIndex,
        'startColumnIndex': startColumnIndex,
        'endColumnIndex': endColumnIndex
      },
      'mergeType': 'MERGE_ALL'
    };
  };
  const addbackgroundColor = (ind, startRowIndex, endRowIndex, startColumnIndex, endColumnIndex) => {
    return {
      'range': {
        'sheetId': ind,
        'startRowIndex': startRowIndex,
        'endRowIndex': endRowIndex,
        'startColumnIndex': startColumnIndex,
        'endColumnIndex': endColumnIndex
      },
      'cell': {
        'userEnteredFormat': {
          'backgroundColor': {
            'red': 0.0,
            'green': 0.3843137254901961,
            'blue': 0.6627450980392157
          },
          'horizontalAlignment': 'CENTER',
          'verticalAlignment': 'MIDDLE',
          'textFormat': {
            'foregroundColor': {
              'red': 1.0,
              'green': 1.0,
              'blue': 1.0
            },
            'fontSize': 12,
            'bold': true
          }
        }
      },
      'fields': 'userEnteredFormat(backgroundColor,textFormat,horizontalAlignment,verticalAlignment)'
    };
  };
  function getCategoryRanges(dataArray, categories, len) {
    const ranges = [];
    let currentCategory = null;
    let startIndex = null;

    dataArray.forEach((row, index) => {
      const label = row[0];
      if (categories.includes(label)) {
        if (label !== currentCategory) {
          if (currentCategory !== null) {
            ranges.push({ category: currentCategory, start: startIndex + len, end: (index) + len });
          }
          currentCategory = label;
          startIndex = index;
        }
      } else if (currentCategory !== null) {
        ranges.push({ category: currentCategory, start: startIndex + len, end: (index) + len });
        currentCategory = null;
        startIndex = null;
      }
    });

    if (currentCategory !== null) {
      ranges.push({ category: currentCategory, start: startIndex + len, end: (dataArray.length) + len });
    }
    return ranges;
  }
  async function batchUpdate(spreadsheetId, spreedSheetData, title, times, find, replacement, callback) {
    const requests = [];
    // Change the spreadsheet's title.
    requests.push({
      updateSpreadsheetProperties: {
        properties: {
          'title': title,
        },
        fields: 'title',
      },
    });
    await spreedSheetData.map(async (v, ind) => {
      if (v[v.label] === true) {
        if (typeof v.data === 'object' && !Array.isArray(v.data)) {
          let index = 0;
          if (v['Flowsheet Design Summary'] === true) {
            if (v.data.FlowsheetDiagram) {

            } else {
              requests.push({
                'updateSheetProperties': {
                  'properties': {
                    'sheetId': 0,
                    'title': 'Flowsheet Design Summary',
                  },
                  'fields': 'title'
                }
              }, {
                updateDimensionProperties: {
                  range: {
                    sheetId: 0,
                    dimension: 'COLUMNS',
                    startIndex: 0,
                    endIndex: 1,
                  },
                  properties: {
                    pixelSize: 200,
                  },
                  fields: 'pixelSize',
                },
              }, {
                'repeatCell': {
                  'range': {
                    'sheetId': 0,
                    'startRowIndex': 1,
                    'endRowIndex': 13,
                    'startColumnIndex': 1,
                    'endColumnIndex': v.data.length - 2
                  },
                  'cell': {
                    'userEnteredFormat': {
                      'numberFormat': {
                        'type': 'NUMBER',
                        'pattern': '#,##0.00'
                      }
                    }
                  },
                  'fields': 'userEnteredFormat.numberFormat'
                }
              });
              // requests.push({
              //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 5, v.data.StreamProperty.length + 7, 0, 1),
              // }, {
              //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 5, v.data.StreamProperty.length + 7, 1, 2),
              // }, {
              //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 5, v.data.StreamProperty.length + 7, 2, 3),
              // }, {
              //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 5, v.data.StreamProperty.length + 6, 3, 5),
              // }, {
              //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 16, v.data.StreamProperty.length + 17, 0, 2),
              // }, {
              //   'repeatCell': addbackgroundColor(0, v.data.StreamProperty.length + 6, v.data.StreamProperty.length + 7, 3, 5)
              // }, {
              //   'repeatCell': addbackgroundColor(0, v.data.StreamProperty.length + 17, v.data.StreamProperty.length + 18, 0, 7)
              // },
              //   // {
              //   //   'mergeCells': mergeCellGoogleSheet(0, v.data.StreamProperty.length + 28, v.data.StreamProperty.length + 50, 0, 26),
              //   // }
              // );
            }
          } else {
            requests.push({
              'addSheet': {
                'properties': {
                  'sheetId': ind,
                  'title': v.label,
                }
              }
            }, {
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 1,
                },
                properties: {
                  pixelSize: 200,
                },
                fields: 'pixelSize',
              },
            },);
          }
          Object.keys(v.data).map((d, dataInd) => {
            let inc = 3;
            if (v.label === 'RO/NF Unit System-Level Summary') {
              v.data[dataInd].map((ele, vdataInd) => {
                if (ele.indexOf('Stage') === 0) {
                  inc = vdataInd + 1;
                }
              });
            }
            requests.push({
              'autoResizeDimensions': {
                'dimensions': {
                  'sheetId': ind,
                  'dimension': 'COLUMNS',
                  'startIndex': 0,
                  'endIndex': 50
                }
              }
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': index,
                  // 'endRowIndex': (v.label === 'RO/NF Unit System-Level Summary' || v.label === 'RO/NF Unit Stage-Level Summary') ?
                  //   ((v.label === 'RO/NF Unit System-Level Summary' && index === 0) ? index + 1 : index + inc) : ((v.label === 'DSSRO Section Summary' && index === 16) ? index + 3 : index + 1),
                  'endRowIndex': (v.label === 'RO/NF Unit System-Level Summary' || v.label === 'RO/NF Unit Stage-Level Summary')
                    ? ((v.label === 'RO/NF Unit System-Level Summary' && index === 0) ? index + 1 : index + inc)
                    : index + 1,
                  'startColumnIndex': 0,
                  'endColumnIndex': v.data[d][1].length
                },
                'cell': {
                  'userEnteredFormat': {
                    'padding': {
                      'top': 0,
                      'right': 10,
                      'bottom': 0,
                      'left': 10
                    },
                    'backgroundColor': {
                      'red': 0.0,
                      'green': 0.3843137254901961,
                      'blue': 0.6627450980392157
                    },
                    'horizontalAlignment': 'CENTER',
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'foregroundColor': {
                        'red': 1.0,
                        'green': 1.0,
                        'blue': 1.0
                      },
                      'fontSize': 12,
                      'bold': true
                    }
                  }
                },
                'fields': 'userEnteredFormat(backgroundColor,textFormat,horizontalAlignment,padding)'
              }
            });
            if (v.label === 'RO/NF Unit Stage-Level Summary') {
              requests.push({
                'mergeCells': mergeCellGoogleSheet(ind, index + 1, index + 2, 4, 7),
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, index + 1, index + 2, 9, 11),
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, index + 1, index + 2, 11, 13),
              },);
            }
            if (v.label === 'RO/NF Unit System-Level Summary' && index !== 0) {
              let flag = false;
              v.data[dataInd].map((ele, vdataInd) => {
                if (ele.indexOf('Stage') === 0 && vdataInd === 3) {
                  flag = true;
                }
              });
              requests.push({
                'mergeCells': mergeCellGoogleSheet(ind, index, index + 1, 0, 2),
              });
              if (flag) {
                requests.push({
                  'mergeCells': mergeCellGoogleSheet(ind, index + 1, index + 2, 0, 3),
                });
                requests.push({
                  'mergeCells': mergeCellGoogleSheet(ind, index + 2, index + 3, 5, 7),
                });
              } else {
                requests.push({
                  'mergeCells': mergeCellGoogleSheet(ind, index + 1, index + 2, 5, 7),
                });
              }
            }
            index += v.data[d].length + 5;
          });
          if (v.label === 'DSSRO Section Summary') {
            const arrData = ['DSSRO Overview', 'DSSRO Flow Summary (Element Level)', 'DSSRO Stream Composition'];
            arrData.map((ele, parentInd) => {
              const baseLengths = [
                0,
                v.data[arrData[0]].length + 5,
                v.data[arrData[0]].length + v.data[arrData[1]].length + 10
              ];
              const count = baseLengths[parentInd];
              v.data[ele].map((dssroEle, childInd) => {
                if (dssroEle.length === 1) {
                  const startRow = childInd + count;
                  const colSpan = v.data[ele][1].length;
                  requests.push(
                    { 'repeatCell': addbackgroundColor(ind, startRow, startRow + 2, 0, colSpan) },
                    { 'mergeCells': mergeCellGoogleSheet(ind, startRow, startRow + 1, 0, colSpan) }
                  );
                }
              });
            });
            requests.push({
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 150,
                  'startColumnIndex': 2,
                  'endColumnIndex': v.data.length - 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'numberFormat': {
                      'type': 'NUMBER',
                      'pattern': '#,##0.00'
                    }
                  }
                },
                'fields': 'userEnteredFormat.numberFormat'
              }
            });
          }
          if (v.label === 'RO/NF Unit Stage-Level Summary') {
            requests.push({
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 50,
                  'startColumnIndex': 4,
                  'endColumnIndex': v.data.length - 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'numberFormat': {
                      'type': 'NUMBER',
                      'pattern': '#,##0.00'
                    }
                  }
                },
                'fields': 'userEnteredFormat.numberFormat'
              }
            });
            if (v.data[0][2][8].includes('m/s')) {
              requests.push({
                'repeatCell': {
                  'range': {
                    'sheetId': ind,
                    'startColumnIndex': 8,
                    'endColumnIndex': 9
                  },
                  'cell': {
                    'userEnteredFormat': {
                      'numberFormat': {
                        'type': 'SCIENTIFIC',
                        'pattern': '##0.00E+0'
                      }
                    }
                  },
                  'fields': 'userEnteredFormat.numberFormat'
                }
              });
            }
          }
          if (v.label === 'RO/NF Unit System-Level Summary') {
            if (v.data[0][7][1].includes('m/s')) {
              requests.push({
                'repeatCell': {
                  'range': {
                    'sheetId': ind,
                    'startRowIndex': 7,
                    'endRowIndex': 8
                  },
                  'cell': {
                    'userEnteredFormat': {
                      'numberFormat': {
                        'type': 'SCIENTIFIC',
                        'pattern': '##0.00E+0'
                      }
                    }
                  },
                  'fields': 'userEnteredFormat.numberFormat'
                }
              });
            }
          }
          if (v.label === 'EDI Unit System-Level Summary') {
            requests.push({
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 56,
                  'endRowIndex': 95,
                  'startColumnIndex': 0,
                  'endColumnIndex': 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'horizontalAlignment': 'CENTER',
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    },
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 33,
                  'endRowIndex': 46,
                  'startColumnIndex': 2,
                  'endColumnIndex': 3
                },
                'cell': {
                  'userEnteredFormat': {
                    'numberFormat': {
                      'type': 'NUMBER',
                      'pattern': '#,##0.00'
                    }
                  }
                },
                'fields': 'userEnteredFormat.numberFormat'
              }
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 26,
                  'startColumnIndex': 2,
                  'endColumnIndex': 3
                },
                'cell': {
                  'userEnteredFormat': {
                    'numberFormat': {
                      'type': 'NUMBER',
                      'pattern': '#,##0.00'
                    }
                  }
                },
                'fields': 'userEnteredFormat.numberFormat'
              }
            }, {
              'repeatCell': addbackgroundColor(ind, 31, 32, 0, 3)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 32, 33, 0, 3)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 36, 37, 0, 3)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 41, 42, 0, 3)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 56, 66, 0, 1)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 66, 78, 0, 1)
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 78, 96, 0, 1)
            });
          }
          if (v.label === 'DSSRO Loop Summary') {
            Object.keys(v.data).map((ele, index12) => {
              const streamData = v.data[ele]; // DSSRO_Concentrate_Stream or DSSRO_Permeate_Stream
              let len = 0;
              if (index12 > 0) {
                len = streamData.length + 5;
              }
              const categories = ['Ion Concentration', 'Stream Property', 'Saturation Data'];
              const result = getCategoryRanges(streamData, categories, len);
              result.forEach(({ start, end }) => {
                requests.push({
                  'mergeCells': mergeCellGoogleSheet(ind, start, end, 0, 1),
                }, {
                  'repeatCell': {
                    'range': {
                      'sheetId': ind,
                      'startRowIndex': start,
                      'endRowIndex': end,
                      'startColumnIndex': 0,
                      'endColumnIndex': 1
                    },
                    'cell': {
                      'userEnteredFormat': {
                        'horizontalAlignment': 'CENTER',
                        'verticalAlignment': 'MIDDLE',
                        'textFormat': {
                          'fontSize': 10
                        }
                      }
                    },
                    'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
                  }
                });
              });
              v.data[ele].map((ele1, ind1) => {
                if (ele1[0].includes('Permeate Stream (Loop wise) Summary')) {
                  requests.push({
                    'repeatCell': addbackgroundColor(ind, (ind1), (ind1 + 2), 0, v.data[ele][1].length)
                  }, {
                    'mergeCells': mergeCellGoogleSheet(ind, (ind1), (ind1 + 1), 0, v.data[ele][1].length),
                  });

                } else if (ele1[0].includes('Concentrate Stream (Loop wise) Summary')) {
                  requests.push({
                    'repeatCell': addbackgroundColor(ind, ((v.data[ele].length + 5) + ind1), ((v.data[ele].length + 5) + ind1 + 2), 0, v.data[ele][1].length)
                  }, {
                    'mergeCells': mergeCellGoogleSheet(ind, (((v.data[ele].length + 5) + ind1)), ((v.data[ele].length + 5) + ind1 + 1), 0, v.data[ele][1].length),
                  });
                }
              });
            });
            requests.push({
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 1,
                  endIndex: 3,
                },
                properties: {
                  pixelSize: 150,
                },
                fields: 'pixelSize',
              },
            });
          };
        }
        if (Array.isArray(v.data)) {
          requests.push({
            'addSheet': {
              'properties': {
                'sheetId': ind,
                'title': v.label,
              }
            }
          }, {
            updateDimensionProperties: {
              range: {
                sheetId: ind,
                dimension: 'COLUMNS',
                startIndex: 0,
                endIndex: 1,
              },
              properties: {
                pixelSize: 200,
              },
              fields: 'pixelSize',
            },
          }, {
            'repeatCell': {
              'range': {
                'sheetId': ind,
                'startRowIndex': 3,
                'endRowIndex': 50,
                'startColumnIndex': 2,
                'endColumnIndex': v.data[0].length
              },
              'cell': {
                'userEnteredFormat': {
                  'numberFormat': {
                    'type': 'NUMBER',
                  }
                }
              },
              'fields': 'userEnteredFormat.numberFormat'
            }
          }, {
            'repeatCell': addbackgroundColor(ind, 0, v.label === 'Detailed RO/NF Element-Level Data' ? 3 : 1, 0, v.data[0].length)
          });
          if (v.label === 'Detailed RO/NF Element-Level Data') {
            requests.push({
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 2,
                },
                properties: {
                  pixelSize: 200,
                },
                fields: 'pixelSize',
              },
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 49,
                  'startColumnIndex': 0,
                  'endColumnIndex': 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'horizontalAlignment': 'CENTER',
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    }
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 0, 3, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 0, 3, 1, 2),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 3, 5, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 5, 9, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 9, 13, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 13, 19, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 19, 41, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 41, 49, 0, 1),
            });
            if (v.data[11][2].includes('m/s')) {
              requests.push({
                'repeatCell': {
                  'range': {
                    'sheetId': ind,
                    'startRowIndex': 11,
                    'endRowIndex': 12
                  },
                  'cell': {
                    'userEnteredFormat': {
                      'numberFormat': {
                        'type': 'SCIENTIFIC',
                        'pattern': '##0.00E+0'
                      }
                    }
                  },
                  'fields': 'userEnteredFormat.numberFormat'
                }
              });
              // }
            }
          };
          if (v.label === 'Detailed Stream Data') {
            requests.push({
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 2,
                },
                properties: {
                  pixelSize: 150,
                },
                fields: 'pixelSize',
              },
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 43,
                  'startColumnIndex': 0,
                  'endColumnIndex': 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'horizontalAlignment': 'CENTER',
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    }
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 43,
                  'startColumnIndex': 1,
                  'endColumnIndex': v.data.length
                },
                'cell': {
                  'userEnteredFormat': {
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    }
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 2, 24, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 24, 34, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 34, 42, 0, 1),
            });
          };
          if (v.label === 'Feed-Product-Waste Summary') {
            requests.push({
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 2,
                },
                properties: {
                  pixelSize: 150,
                },
                fields: 'pixelSize',
              },
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 43,
                  'startColumnIndex': 0,
                  'endColumnIndex': 1
                },
                'cell': {
                  'userEnteredFormat': {
                    'horizontalAlignment': 'CENTER',
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    }
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 43,
                  'startColumnIndex': 1,
                  'endColumnIndex': v.data.length
                },
                'cell': {
                  'userEnteredFormat': {
                    'verticalAlignment': 'MIDDLE',
                    'textFormat': {
                      'fontSize': 10
                    }
                  }
                },
                'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
              }
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 2, 24, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 24, 34, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 34, 42, 0, 1),
            }, {
              'repeatCell': {
                'range': {
                  'sheetId': ind,
                  'startRowIndex': 1,
                  'endRowIndex': 50,
                  'startColumnIndex': 2,
                  'endColumnIndex': v.data.length - 2
                },
                'cell': {
                  'userEnteredFormat': {
                    'numberFormat': {
                      'type': 'NUMBER',
                      'pattern': '#,##0.00'
                    }
                  }
                },
                'fields': 'userEnteredFormat.numberFormat'
              }
            },);
          }
          if (v.label === 'Antiscalant Dosage Summary') {
            requests.push({
              'mergeCells': mergeCellGoogleSheet(ind, 0, 2, 0, 1),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 0, 2, 1, 2),
            }, {
              'mergeCells': mergeCellGoogleSheet(ind, 0, 1, 2, 4),
            }, {
              'repeatCell': addbackgroundColor(ind, 0, 2, 0, 4),
            });
          }
          if (v.label === 'Flowsheet Diagram') {
            requests.push({
              'mergeCells': mergeCellGoogleSheet(ind, 0, 1, 0, 3),
            }, {
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 26,
                },
                properties: {
                  pixelSize: 200,
                },
                fields: 'pixelSize',
              }
            }, {
              // cell merge dynamic image height / 19 (23.3 one cell height )
              // Math.floor get nearest value of number like 123.333 get the value 124
              'mergeCells': mergeCellGoogleSheet(ind, 1, Math.floor(flowSheetImage.height / 19), 0, 26),
            });
          }
          if (v.label === 'EDI Schematic Diagram') {
            ediImage.map((ele) => {
              const mergeCellHeight = Math.ceil(ele.height / 19);
              ele.cellIndex = ediColumnSpace;
              requests.push({
                'repeatCell': addbackgroundColor(ind, ediColumnSpace - 2, ediColumnSpace - 1, 0, 9)
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, ediColumnSpace - 2, ediColumnSpace - 1, 0, 9)
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, ediColumnSpace, ediColumnSpace + mergeCellHeight, 0, 9),
              }, {
                'repeatCell': {
                  'range': {
                    'sheetId': ind,
                    'startRowIndex': ediColumnSpace,
                    'endRowIndex': ediColumnSpace + 1,
                    'startColumnIndex': 0,
                    'endColumnIndex': 1
                  },
                  'cell': {
                    'userEnteredFormat': {
                      'horizontalAlignment': 'CENTER',
                      'verticalAlignment': 'MIDDLE',
                      'textFormat': {
                        'fontSize': 10
                      }
                    }
                  },
                  'fields': 'userEnteredFormat(textFormat,horizontalAlignment,verticalAlignment)'
                }
              });
              ediColumnSpace += mergeCellHeight + 4;
            });
          }
          if (v.label === 'DSSRO Schematic Diagram') {
            clroImage.map((ele, inddex) => {
              const mergeCellHeight = Math.ceil(ele.height / 19);
              imageIndex.push(dssroColumnSpace);
              requests.push({
                'mergeCells': mergeCellGoogleSheet(ind, dssroColumnSpace - 2, dssroColumnSpace - 1, 0, 7)
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, dssroColumnSpace - 1, dssroColumnSpace, 0, 7)
              }, {
                'mergeCells': mergeCellGoogleSheet(ind, dssroColumnSpace, dssroColumnSpace + mergeCellHeight, 0, 7),
              });
              if (ele.text2) {
                requests.push({
                  'repeatCell': addbackgroundColor(ind, dssroColumnSpace - 3, dssroColumnSpace - 2, 0, 7)
                }, {
                  'mergeCells': mergeCellGoogleSheet(ind, dssroColumnSpace - 3, dssroColumnSpace - 2, 0, 7)
                });
                dssroColumnSpace += mergeCellHeight + 4;
              } else {
                dssroColumnSpace += mergeCellHeight + 5;
              }
            });
            requests.push({
              updateDimensionProperties: {
                range: {
                  sheetId: ind,
                  dimension: 'COLUMNS',
                  startIndex: 0,
                  endIndex: 26,
                },
                properties: {
                  pixelSize: 100,
                },
                fields: 'pixelSize',
              }
            });
          }
        };
      };
      // if (v['Flowsheet Design Summary'] === false) {
      // }
    });
    try {
      // Add additional requests (operations) ...
      const batchUpdateRequest = { 'requests': requests };
      await window.gapi.client.sheets.spreadsheets.batchUpdate({
        'spreadsheetId': spreadsheetId,
        resource: batchUpdateRequest,
      }).then((response) => {
        // const findReplaceResponse = response.result.replies[1].findReplace;
        if (callback) callback(response);
      });
    } catch (err) {
      // document.getElementById('content').innerText = err.message;
      console.error('error', err);
    }
  };
  const cssbatchUpdate = async (spreadsheetId, spreedSheetData, title, times, find, replacement, callback) => {
    const requests = [];
    spreedSheetData.map((v, ind) => {
      if (v[v.label] === true) {
        let dataLength = 0;
        // To fix the Google sheet issue for stand alone EDI case. In such cases earlier entire flowsheet summary tab was showing one single blue cell
        // for example https://docs.google.com/spreadsheets/d/1CfJQjbIHZXnVoTnv654MnA1XaotMEISEFMN0QAjGJxI/edit?gid=0#gid=0
        if (Object.prototype.toString.call(v.data) === '[object Object]') {
          dataLength = Math.max(Object.values(v.data).reduce((sum, arr) => sum + arr.length, 0) + (Object.keys(v.data).length - 1) * 5);
        } else {
          dataLength = v.data.length;
        }
        requests.push({
          'repeatCell': {
            'range': {
              'sheetId': ind,
              'startRowIndex': 0,
              'endRowIndex': 50,
              'startColumnIndex': 0,
              'endColumnIndex': 50
            },
            'cell': {
              'userEnteredFormat': {
                'padding': {
                  'top': 0,
                  'right': 10,
                  'bottom': 0,
                  'left': 10
                },
              }
            },
            'fields': 'userEnteredFormat.padding'
          }
        }, {
          'mergeCells': mergeCellGoogleSheet(ind, dataLength + 4, dataLength + 6, 0, 8),
        }, {
          'autoResizeDimensions': {
            'dimensions': {
              'sheetId': ind,
              'dimension': 'COLUMNS',
              'startIndex': 1,
              'endIndex': 50
            }
          }
        });
      }
    });
    try {
      // Add additional requests (operations) ...
      const batchUpdateRequest = { 'requests': requests };
      await window.gapi.client.sheets.spreadsheets.batchUpdate({
        'spreadsheetId': spreadsheetId,
        resource: batchUpdateRequest,
      }).then((response) => {
        // const findReplaceResponse = response.result.replies[1].findReplace;
        if (callback) callback(response);
      });
    } catch (err) {
      // document.getElementById('content').innerText = err.message;
      console.error('error', err);
    }
  };
  async function batchUpdateValues(spreedSheetID, spreedSheetData, valueInputOption1, _values, callback) {
    const data = [];
    await spreedSheetData.map((v) => {
      if (v[v.label] === true) {
        if (typeof v.data === 'object' && !Array.isArray(v.data)) {
          let index = 1;
          Object.keys(v.data).map((d) => {
            data.push({
              'range': `${v.label}!A${index}`,
              'values': v.data[d]
            });
            index += v.data[d].length + 5;
          });
          data.push({
            'range': `${v.label}!A${index}`,
            'values': [[translateObject('Disclaimer_text')]]
          });
        } else if (Array.isArray(v.data)) {
          if (v.data && v.data.length > 0) {
            data.push({
              'range': `${v.label}!A1`,
              'values': v.data
            });
            if (v.label === 'Flowsheet Diagram') {
              data.push({
                'range': `${v.label}!A${Math.floor(flowSheetImage.height / 19) + 5}`,
                'values': [[translateObject('Disclaimer_text')]]
              });
            } else {
              const disclaimer = v.label === 'DSSRO Schematic Diagram' ? dssroColumnSpace : ediColumnSpace;
              let range = `${v.label}!A${v.data.length + 5}`;
              if (v.label === 'DSSRO Schematic Diagram' || v.label === 'EDI Schematic Diagram') {
                range = `${v.label}!A${disclaimer}`;
              }
              data.push({
                range,
                'values': [[translateObject('Disclaimer_text')]]
              });
            }
          }
        } else if (v.data) {
          data.push({
            'range': `${v.label}!A1`,
            'values': [[v.data]]
          });
        }
      };
    });
    // Additional ranges to update.
    const body = {
      'data': data,
      valueInputOption: valueInputOption1
    };
    try {
      await window.gapi.client.sheets.spreadsheets.values.batchUpdate({
        spreadsheetId: spreedSheetID,
        resource: body,
      }).then((response) => {
        // const { result } = response;
        if (callback) callback(response);
      });
    } catch (err) {
      // added by chandrashekhar when getting blank google sheet and status code 400 call automatically.
      if (err.status === 400) {
        let retryCount = 0;
        const intervalId = setInterval(() => {
          if (retryCount < 3) {
            batchUpdateValues(spreedSheetID, spreedSheetData, valueInputOption1, _values, callback);
            retryCount += 1;
          } else {
            clearInterval(intervalId);
          }
        }, 1000);
      }
    }
  }
  // useEffect(() => {
  //   function initClient() {
  //     window.gapi.client.init({
  //       apiKey: API_KEY,
  //       clientId: CLIENT_ID,
  //       discoveryDocs: DISCOVERY_DOCS,
  //       scope: SCOPES
  //     }).then(() => {
  //       // Sign in the user if not already signed in
  //       if (!window.gapi.auth2.getAuthInstance().isSignedIn.get()) {
  //         window.gapi.auth2.getAuthInstance().signIn();
  //       }
  //     });
  //   }

  //   window.gapi.load('client:auth2', initClient);
  // }, []);

  // const grantAccess = async () => {
  //   try {
  //     await window.gapi.client.drive.permissions.create({
  //       fileId: FILE_ID,
  //       resource: {
  //         role: 'writer',
  //         type: 'user',
  //         emailAddress: SERVICE_ACCOUNT_EMAIL
  //       }
  //     });
  //     alert('Service account granted access successfully');
  //   } catch (error) {
  //     console.error('Error granting access:', error);
  //     alert('Failed to grant access');
  //   }
  // };
  const grantAccessToAdmin = async (fileId, emailAddress = 'ghg-service-account@gbl-ist-vwts-dgl.iam.gserviceaccount.com', role = 'writer') => {
    try {
      const accessToken = window.gapi.auth.getToken().access_token;
      const response = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}/permissions`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          role, // 'reader', 'writer', or 'commenter'
          type: 'user',
          emailAddress,
          sendNotificationEmail: false // Optional: suppress email notification
        })
      });
      return await response.json();
    } catch (error) {
      console.error('Error granting permission:', error);
    }
  };
  const insertFlowsheetDiagram = async (steetIDs, sheetname, range, flowSheetImage) => {
    let operation = 'flowsheetdiagram';
    if (Object.prototype.toString.call(range) === '[object Array]') {
      operation = 'dssroschematicdiagram';
    } else if (range === 'edi') {
      operation = 'edischematicdiagram';
    }
    const obj = {
      'emailId': sessionStorage.getItem('user_email'),
      operation,
      identify: 'winflows',
      'fetTabData': {
        steetIDs,
        sheetname,
        range,
        flowSheetImage,
        fileName: `winflow-flowsheet-image ${Math.random().toString(36).slice(2, 15)}.png`,
      }
    };
    await FetchGoogleSpredSheetData(obj);
  };
  function injectArial(svgText) {
    const styleTag = `
    <style>
      text, tspan {
        font-family: Arial, sans-serif;
      }
    </style>
  `;
    // Insert into <svg> right after the opening tag
    return svgText.replace(
      /<svg([^>]*)>/,
      `<svg$1>${styleTag}`
    );
  }
  const convertSVGtoPNG = async (data) => {
    let canvas = document.getElementById('myCanvas');
    const widthHeight = 5000;
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'myCanvas';
      document.body.appendChild(canvas);
    }
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, widthHeight, widthHeight);
    const promises = data.map((ele) => {
      // const svgText = ele.svg;
      const svgText = injectArial(ele.svg); // force Arial
      return new Promise((resolve) => {
        let width = 500; let height = 500;
        const viewBoxMatch = svgText.match(/viewBox="([^"]+)"/);
        if (viewBoxMatch) {
          const viewBoxValues = viewBoxMatch[1].split(' ').map(Number);
          width = viewBoxValues[2];
          height = viewBoxValues[3];
        }
        canvas.width = width;
        canvas.height = height;
        ctx.clearRect(0, 0, widthHeight, widthHeight);
        const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);
        const img = new Image();
        img.onload = () => {
          ctx.clearRect(0, 0, widthHeight, widthHeight);
          ctx.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);
          const pngUrl = canvas.toDataURL('image/png');
          const obj = { src: pngUrl, width: img.width, height: img.height };
          if (ele.text) obj.text = ele.text;
          if (ele.text1) obj.text1 = ele.text1;
          if (ele.text2) obj.text2 = ele.text2;
          resolve(obj);
        };
        img.src = url;
      });
    });
    return Promise.all(promises);
  };
  const getCLROImage = async () => {
    const data = report_invoice.report_dict.clro_schematic;
    const clro_schematic_data = [];
    const unitop_output = JSON.parse(localStorage.getItem('ro_ouput_data'));
    if (Object.keys(data).length > 0) {
      Object.keys(data).map((ele) => {
        const closedLoop = data[ele]['Prod Cycle'];
        const bringPurge = data[ele]['Brine Purge'];
        const unit = data[ele].units;
        const clro_captu = unitop_output[ele].output_user.captu_ro;
        const closedLoopMarkup = ReactDOMServer.renderToStaticMarkup(
          <ProductionSVG loop='true' clro_captu={clro_captu} closedLoop={closedLoop} schmeticUnits={unit} />
        );
        const brinePurgeMarkup = ReactDOMServer.renderToStaticMarkup(
          <ProductionSVG loop='false' clro_captu={clro_captu} bringPurge={bringPurge} schmeticUnits={unit} />
        );
        clro_schematic_data.push({ svg: closedLoopMarkup, text: 'Production Loop', text1: `CL Sequence Duration - ${closedLoop['CL Sequence Duration'].toFixed(2)} min`, text2: `${ele} Schematic` });
        clro_schematic_data.push({ svg: brinePurgeMarkup, text: 'Brine Purge', text1: `BP Sequence Duration - ${bringPurge['BP Sequence Duration'].toFixed(2)} min`, text2: '' });
      });
    }
    const arr = await convertSVGtoPNG(clro_schematic_data);
    const canvas = document.getElementById('myCanvas');
    if (canvas) canvas.remove();
    return arr;
  };
  async function create(title, callback) {
    let steetIDs = '1z30THgs-ipKI5pBBMeQ1tn48eylPaGE_xJbBPtZ7uNs';
    // let steetIDs = '1EpV_0bM9goWMlY1wkC0P7mDZBYR6Y4S3N3FnLPeK5B4';
    try {
      // const obj = {
      //   'emailId': sessionStorage.getItem('user_email'),
      //   operation: 'createspreadsheet',
      //   identify: 'winflows'
      // };
      // const data = await FetchGoogleSpredSheetData(obj);
      // console.log(data, data.data.id);
      window.gapi.client.sheets.spreadsheets.create({
        properties: { title },
      }).then(async (response) => {
        let emitted = false; // ensure we emit once
        try {
          if (callback) callback(response);
          if (report_invoice.report_dict && report_invoice.report_dict.clro_schematic) {
            clroImage = await getCLROImage();
          }
          let ediDictData = localStorage.getItem('edi-dict');
          if (ediDictData) {
            ediDictData = JSON.parse(ediDictData);
            if (ediDictData.EDI) {
              Object.keys(ediDictData.EDI).map((ele) => {
                const ediDiagram = ReactDOMServer.renderToStaticMarkup(
                  <SchematiDiagramSVG
                    cocurrent={ediDictData.EDI[ele].co_current}
                    ediDetails={{ id: ele }}
                  />
                );
                ediImage.push({ svg: ediDiagram, text: `${ele.toUpperCase()} - EDI Schematic` });
              });
            }
          }
          if (ediImage.length > 0) {
            ediImage = await convertSVGtoPNG(ediImage);
            const canvas = document.getElementById('myCanvas');
            if (canvas) canvas.remove();
          }
          const GoogleFinalData = await jsontocsvConvertion(report_invoice.report_dict, checkDisabled(), translateObject);
          steetIDs = response.result.spreadsheetId;
          await grantAccessToAdmin(steetIDs);
          setSpreadSheetID(steetIDs);
          window.open(
            `https://docs.google.com/spreadsheets/d/${steetIDs}/edit#gid=0`
          );
          // notify parent with the created sheet id
          await batchUpdate(steetIDs, GoogleFinalData, text, '0');
          await insertFlowsheetDiagram(steetIDs, 'Flowsheet Diagram', 'A2', flowSheetImage);
          await batchUpdateValues(steetIDs, GoogleFinalData, 'USER_ENTERED');
          if (imageIndex.length !== 0) {
            await insertFlowsheetDiagram(steetIDs, 'DSSRO Schematic Diagram', imageIndex, clroImage);
          }
          if (ediImage.length > 0) {
            await insertFlowsheetDiagram(steetIDs, 'EDI Schematic Diagram', 'edi', ediImage);
          }
          await updateSpreadsheetAndHideSheet(steetIDs);
          await cssbatchUpdate(steetIDs, GoogleFinalData, 'MainSheet', '1');
          // notify parent after all ops done
          if (typeof onSheetCreated === 'function' && !emitted) { onSheetCreated(steetIDs); emitted = true; }
          dssroColumnSpace = 3;
          ediColumnSpace = 2;
          clroImage = [];
          imageIndex = [];
          ediImage = [];
          // exportNamedSheetWithImage(flowSheetImage, steetIDs);
          // const exportUrl = `https://docs.google.com/spreadsheets/d/${steetIDs}/export?format=xlsx`;
          // const link = document.createElement('a');
          // link.href = exportUrl;
          // link.download = 'Spreadsheet.xlsx';
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
        } catch (innerErr) {
          console.error('Spreadsheet post-create ops failed:', innerErr);
          // still emit the id so caller can proceed or handle error
          if (typeof onSheetCreated === 'function' && !emitted && steetIDs) { onSheetCreated(steetIDs); emitted = true; }
        }
      });
    } catch (err) {
      dssroColumnSpace = 3;
      ediColumnSpace = 2;
      clroImage = [];
      imageIndex = [];
      ediImage = [];
      console.error('error', err);
    }
  }
  /**
    * Sign in the user upon button click.
    */
  function handleAuthClick() {
    tokenClient.callback = async (resp) => {
      if (resp.error !== undefined) {
        throw resp;
      }
      await create('sheet1');
    };

    if (window.gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      tokenClient.requestAccessToken({ prompt: '' });
    }
  }

  /**
    * Sign out the user upon button click.
    */
  useEffect(() => {
    gapiLoaded();
    gisLoaded();
    setTimeout(() => {
      handleAuthClick();
    }, 1000);
  }, []);
  return '';
}

export default CreateGoogleSheet;